export default __webpack_public_path__ + "static/media/0w.e681701c.png";